import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "align-fixed",
  "use": "align-fixed-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"align-fixed\"><path d=\"M1 4a1 1 0 011-1h2a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V4zM11 4a1 1 0 011-1h2a1 1 0 011 1v8a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z\" fill=\"currentColor\" /><path d=\"M8 6v4\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol